// @flow
import { formatValue } from '../../../../lib/usage-formatters';
import I18n from '../../../../lib/i18n';

const formatValues = (currentValue: number, maxValue: number) => ({
  current: currentValue === 0 ? I18n.t('nothing') : formatValue(currentValue, 'DURATION'),
  max: formatValue(maxValue, 'DURATION'),
});

export default formatValues;
